import React, { createElement, useState, useRef } from 'react';
import moduleCss from './index.module.scss'

export interface DateTabsProps {
    style?: object
    children?: any;
    tabList: {
        title: string,
        isOpen: boolean
    }[];

    tabWidth?: number
    tabHeight?: number
    tabGap?: number
    contentGap?: number

    isHasAfterTabTitle: boolean
    afterTabTitleText?: string
    afterTabTitleStyle?: object
    afterTabTitleActiveStyle?: object

    tabStyle?:object // 普通态

    tabActiveStyle?: object // 激活态

    __designMode: string
}

const DateTabs: React.FC<DateTabsProps> = (props) => {
    const {
        style, tabList, children,
        tabWidth, tabHeight, tabGap, contentGap,
        isHasAfterTabTitle, afterTabTitleStyle, afterTabTitleText, afterTabTitleActiveStyle,
        tabStyle, tabActiveStyle, __designMode } = props;

    const [ current, setCurrent ] = useState(0)
    const [ X, setX ] = useState(0) // 偏移量

    const overflowWp = useRef()
    const overflowContent = useRef()

    const changeX = (action: 'prev' | 'next') => {

        if (action === 'prev') {
            setX((X - 1) < 0 ? 0 : X - 1)
            const next = (current - 1) < 0 ? 0 : current - 1
            if (tabList[next].isOpen) {
                setCurrent(next)
            }
        } else {
            const next = (current + 1) > tabList.length - 1 ? tabList.length - 1 : current + 1
            if (tabList[next].isOpen) {
                setCurrent(next)
            }
            const wpRect = overflowWp.current.getBoundingClientRect()
            const contentRect = overflowContent.current.getBoundingClientRect()

            // 最后一个 tab 减去两个1px的边框，再减去一个 tab 的宽度和间距，小于容器的right，就不让继续往右了
            if (contentRect.right - 2 - tabWidth - tabGap < wpRect.right) {
                return
            }

            setX( X + 1)
        }
    }

    return (
        <div className={moduleCss.tabs} style={style}>
            <div className={moduleCss.tabsTitleList}>
                <div className={moduleCss.before}>
                    10
                    <span>月</span>
                </div>
                <div className={`${moduleCss.nav} ${moduleCss.prev}`} onClick={() => changeX('prev')}>
                   <img src="https://x0.ifengimg.com/ucms/2022_42/8DF69661F469DF5E1D90A64B782168F1583A8956_size1_w30_h40.png" alt="prev" />
                </div>
                <div className={moduleCss.overflowContent} ref={overflowWp}>
                    <div style={{ transform: `translateX(-${X * tabWidth + X * tabGap}px)` }}>
                        {
                            tabList.map((tab, index) => {
                                return (
                                    <div
                                        className={moduleCss.tabTitle}
                                        key={index}
                                        onClick={__designMode === 'design' ? () => setCurrent(index) : () => {}}
                                        onMouseOver={() => {
                                            if (tab.isOpen) {
                                                setCurrent(index)
                                            }
                                        }}
                                        style={{ width: `${tabWidth}px`, height: `${tabHeight}px`, marginRight: `${tabGap}px`, ...tabStyle, ...(current === index ? tabActiveStyle : {}) }}
                                        ref={index === tabList.length - 1 ? overflowContent : null}
                                    >
                                        {tab?.title}
                                        {
                                            isHasAfterTabTitle && <span style={{ ...afterTabTitleStyle, ...(current === index ? afterTabTitleActiveStyle : {}) }}>{afterTabTitleText}</span>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>

                </div>
                <div className={`${moduleCss.nav} ${moduleCss.next}`} onClick={() => changeX('next')}>
                    <img src="https://x0.ifengimg.com/ucms/2022_42/7F1D3E07CD9F873B35FF910DB3CBD9DBABFB373C_size1_w30_h40.png" alt="next" />
                </div>
            </div>
            <div style={{ marginTop: `${contentGap}px` }}>
                {
                    children.map((item, index) => {
                        return (
                            <div style={{ display: index === current ? 'block' : 'none' }}>
                                {item}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default DateTabs;
